<aside [ngClass]="{'active': notesService.notePanelIsOpened}">
  <div class="dimming" (click)="notesService.notePanelIsOpened = !notesService.notePanelIsOpened"></div>
  <div class="panels panel-left notes notes-panel Spacebox__lr-small Spacebox__t-small main-notes-panel">
    <header class="Flexbox Flexbox__just-space-around Spacebox__b-medium Spacebox__lr-small Spacebox__t-small">
      <div class="title fs5 bold">
        {{'Notes'}}
      </div>
      <span class="close icon__cross" (click)="notesService.notePanelIsOpened = false"></span>
    </header>

    <section class="Flexbox filters">
      <div id="all-notes" class="notes-tab" [ngClass]="{selected: notesFilter == 'all'}" (click)="notesFilter = 'all'">
        <span>{{'ALL_NOTES' | translate}}</span>
        <span class="bar"></span>
      </div>
      <div id="my-notes" class="notes-tab" [ngClass]="{selected: notesFilter == 'my'}" (click)="notesFilter = 'my'">
        <span>{{ 'MY_NOTES' | translate }}</span>
        <span class="bar"></span>
      </div>
      <div id="other-notes" class="notes-tab" [ngClass]="{selected: notesFilter == 'others'}" (click)="notesFilter = 'others'">
        <span> {{ 'OTHER_NOTES' | translate}}</span>
        <span class="bar"></span>
      </div>
    </section>
    <ul *ngIf="(notesFilter == 'all' || notesFilter == 'my' || notesFilter == 'others')" class="notes">
      <li *ngFor="let note of notes | actorFilter:notesFilter:actorId" class="note" [attr.id]="'note_'+note.id">
        <div class="avatar">
          <span class="note-image" *ngIf="(note.actor.photo!=null);else noteprofileimage" style.background-image="url('{{note.actor?.photo[0]?.url}}')"></span>
          <ng-template #noteprofileimage>
            <span class="note-image"  style.background-image=""></span>
          </ng-template>
          <div class="note-info">
            <span class="bold fs6 author note_author">{{note.actor.name[0].text}}</span>
            <span class="note-time">{{note.meta.created | date: "dd MMMM y H:mm"}}</span>
            <span class="new-note" id="new-note-title" *ngIf="!note.read">New</span>
          </div>
        </div>
        <div class="note-content" >
          <div *ngIf="(note.text.length > 100 && !note.readMore) ;else readLess">
            <div class="note-text readmorenotes" [innerHTML]="note.text | slice:0:100"></div>
            <a class="expand-text"  (click)="note.readMore = true"> Read more </a>
          </div>
          <ng-template #readLess>
            <div class="note-text" [innerHTML]="note.text"></div>
            <a class="expand-text"  *ngIf="note.text.length>100" (click)="note.readMore = false"> Read less </a>
          </ng-template>
        </div>
      </li>
    </ul>

    <form class="note-input Marginbox__t-medium Marginbox__b-tiny" genPermissionSchemaRestrict
      [permissionSchemaKey]="'noteWrite'" [nonePermissionAction]="'hide'"
      [nonePermissionOnHideMsg]="'You do not have permissions to add a new note'"
      [nonePermissionOnHideMsgClass]="'Flexbox Flexbox__just-center Flexbox__box-direction-column attachments-sub-header'">
      <p-editor *ngIf="notesService.notePanelIsOpened" placeholder="{{'Enter your note' | translate}}" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="valueChangeEvent($event)" [(ngModel)]="text" class="notes-richedit notesSidePanel">
        <p-header>
       <span class="ql-formats">
         <button class="ql-bold" aria-label="Bold"></button>
         <button class="ql-italic" aria-label="Italic"></button>
         <button class="ql-underline" aria-label="Underline"></button>
         <select class="ql-size">
          </select>
          <button class="ql-list" value="ordered" aria-label="Ordered List"></button>
          <button class="ql-list" value="bullet" aria-label="Unordered  List"></button>
         <select class="ql-align">
          </select>
        </span>
        </p-header>
      </p-editor>

      <div class="note-input-options Flexbox Flexbox_rows Flexbox__just-end notes-add-note-section">
        <div class="note-actions" *ngIf="notesService.editModeIsSupported">
          <input type="button" class="btn btn-primary" value="{{'Add note'| translate}}" (click)="postNote()"
            [disabled]="addNoteButtonChange" />
        </div>
      </div>
    </form>
  </div>
</aside>
